{
  "currentBid": "現在の入札額",
  "startingBid": "開始価格",
  "startingPrice": "開始価格",
  "buyNow": "即決購入",
  "buyNowUnavailable": "入札が開始されたため、即決購入はご利用いただけません。",
  "reserveMet": "最低落札価格に到達",
  "reserveNotMet": "最低落札価格に未到達",
  "reserveNotMetTitle": "最低落札価格に未到達",
  "reserveNotMetBody": "最高入札額が出品者の設定した最低落札価格に達しなかったため、落札者は決定せず、注文も作成されません。",
  "noReserve": "最低落札価格なし",
  "reservePrice": "最低落札価格",
  "minimumIncrement": "最低入札単位",
  "minimumBid": "最低入札額は {amount} です",
  "yourBid": "入札額（最低 {amount}）",
  "endsIn": "オークション終了まで",
  "timeRemaining": "残り時間",
  "auctionEnds": "終了日時",
  "ended": "終了",
  "auctionEnded": "このオークションは終了しました。",
  "auctionEndedSold": "このオークションは終了し、落札されました。",
  "youWon": "🎉 落札されました！",
  "autoExtendEnabled": "自動延長あり",
  "autoExtended": "オークションが {seconds} 秒延長されました",
  "placeBid": "入札する",
  "signInToBid": "ログインして入札",
  "ownAuction": "ご自身の出品には入札できません。",
  "biddingPaused": "他の購入者が即決購入の手続き中です。入札は最大10分間停止されます。",
  "bidHistory": "入札履歴",
  "winningBid": "落札価格",
  "highestBidder": "最高入札者",
  "youAreWinning": "現在あなたが最高入札者です",
  "outbid": "入札を上回られました",
  "sold": "落札済み",
  "paymentPending": "支払い待ち",
  "payNow": "支払う",
  "preparingPayment": "支払いを準備しています…",
  "preparePayment": "支払いを準備",
  "viewOrder": "注文を見る",
  "loadingOrder": "注文を読み込んでいます…",
  "disputeHold": "この注文には異議申し立てがあるため、支払いは保留中です。",
  "promoteListing": "この出品をプロモーション",
  "bids": "入札 {count} 件",
  "watchers": "ウォッチ {count} 人",
  "yourMaxBid": "自動入札の上限額",
  "bidPlaced": "入札しました",
  "invalidAmount": "有効な金額を入力してください",
  "bidTooLow": "入札額は {amount} 以上である必要があります。",
  "shipping": "配送",
  "collection": "店頭受取",
  "payment": "支払い",
  "seller": "出品者",
  "buyer": "購入者",
  "condition": "状態",
  "grade": "グレード",
  "population": "鑑定枚数（ポピュレーション）",
  "certificateNumber": "鑑定番号",
  "watchlist": "ウォッチリスト",
  "addToWatchlist": "ウォッチリストに追加",
  "removeFromWatchlist": "ウォッチリストから削除"
}
